import { Tag } from '~/interfaces/Tag';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Button } from '../ui/button';
import React from 'react';
import TagTooltipIcon from '../icons/TagTooltipIcon';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { useSearchParams } from '@remix-run/react';

const TAG_FILTER_PARAM = 'tag';

export default function TagFilterItem({
  isDisabled,
  isFirstItem,
  onClick,
  tag,
}: {
  isDisabled: boolean;
  isFirstItem: boolean;
  onClick: () => void;
  tag: Tag;
}) {
  const [searchParams] = useSearchParams();
  const [open, setOpen] = React.useState(false);
  const tagFilters = searchParams.getAll(TAG_FILTER_PARAM).map(Number);
  const isChecked = tagFilters.includes(tag.parentTemplateTagId);
  const [checked, setChecked] = React.useState(isChecked);

  React.useEffect(() => {
    setChecked(isChecked);
  }, [isChecked, tag.parentTemplateTagId]);

  return (
    <li
      className={`flex items-center justify-between px-2 py-1 ${isFirstItem ? '' : 'border border-b-0 border-l-0 border-r-0 border-dashed border-taupe-light-75'}`}
    >
      <span className="flex cursor-pointer items-center justify-start gap-x-2">
        <Checkbox
          disabled={isDisabled}
          className={`${isDisabled ? 'cursor-not-allowed bg-neutral-grey-50' : ''}`}
          id={tag.tagTitle}
          onClick={onClick}
          checked={checked}
        />
        <Label
          htmlFor={tag.tagTitle}
          className={`${isDisabled ? 'cursor-not-allowed !opacity-50' : 'cursor-pointer'} p-0 text-base font-extralight text-brown`}
        >
          {tag.tagTitle}
        </Label>
      </span>
      <TooltipProvider delayDuration={300}>
        <Tooltip open={open} onOpenChange={(newOpen) => setOpen(newOpen)}>
          <TooltipTrigger asChild>
            <Button type="button" className="relative bottom-[1px] p-2" onClick={() => setOpen(!open)}>
              <TagTooltipIcon />
            </Button>
          </TooltipTrigger>
          <TooltipContent className="w-52 bg-green-pale p-4 text-sm font-normal text-brown-dark">
            <p>{tag.tagDefinition}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </li>
  );
}
